var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor cache-delete" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Cache Key"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("Silinecek cache key"),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.key,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "key", $$v)
              },
              expression: "clone.key",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          { staticClass: "pattern-toggle" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.clone.usePattern,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "usePattern", $$v)
                  },
                  expression: "clone.usePattern",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("Pattern Matching Kullan")) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.clone.usePattern
          ? _c("div", { staticClass: "pattern-help" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
            ])
          : _c("div", { staticClass: "help-text" }, [
              _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "Sadece tam eşleşen key silinecek. Pattern matching için yukarıdaki checkbox'ı işaretleyin."
                ),
              ]),
            ]),
      ]),
      _vm._v(" "),
      _vm.clone.usePattern ? _c("section", [_vm._m(2)]) : _vm._e(),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "output-info" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "output-attributes" }, [
            _c("div", { staticClass: "attribute-item" }, [
              _c("code", [
                _vm._v("block." + _vm._s("{") + "{'{blockId}'}}.deletedCount"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("Silinen cache sayısı")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "attribute-item" }, [
              _c("code", [
                _vm._v("block." + _vm._s("{") + "{'{blockId}'}}.success"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("İşlem başarılı mı?")]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "help-title" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("pattern")]),
      _vm._v(" "),
      _c("span", [_vm._v("Pattern Matching Nasıl Çalışır?")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pattern-examples" }, [
      _c("div", { staticClass: "example" }, [
        _c("code", [_vm._v("chat*")]),
        _vm._v(" "),
        _c("span", [_vm._v('"chat" ile başlayan tüm key\'ler silinir')]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "example" }, [
        _c("code", [_vm._v("*chat")]),
        _vm._v(" "),
        _c("span", [_vm._v('"chat" ile biten tüm key\'ler silinir')]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "example" }, [
        _c("code", [_vm._v("*chat*")]),
        _vm._v(" "),
        _c("span", [_vm._v('İçinde "chat" geçen tüm key\'ler silinir')]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "example" }, [
        _c("code", [_vm._v("user_session")]),
        _vm._v(" "),
        _c("span", [_vm._v("Tam eşleşme (wildcard yoksa)")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "warning-box" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("warning")]),
      _vm._v(" "),
      _c("div", [
        _c("strong", [_vm._v("Dikkat!")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Pattern matching kullanıldığında birden fazla cache silinebilir. Bu işlem geri alınamaz."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-title" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("output")]),
      _vm._v(" "),
      _c("span", [_vm._v("Çıktı Bilgisi")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }